import _invariant       from 'invariant';
import { createAction } from 'redux-actions';
import Identifier       from '../domain/Identifier';

/**
 * @todo TESTS: Add all
 */
export const enableEditMode = createAction('EDITABLE_CONTENT:EDIT_MODE:ENABLE', () => ({}));


/**
 * @todo TESTS: Add all
 */
export const disableEditMode = createAction('EDITABLE_CONTENT:EDIT_MODE:DISABLE', () => ({}));


/**
 * @todo TESTS: Add all
 */
export const registerEditableContent = createAction(
  'EDITABLE_CONTENT:CURRENT_EDITABLE_CONTENT:REGISTER',
  ({componentId, contentId, friendlyName, initialContent}) => {

    _invariant(componentId instanceof Identifier, 'Expected componentId to be instance of Identifier');

    return {componentId, contentId, friendlyName, initialContent};

  }
);


export const beginEditingContent = createAction(
  'EDITABLE_CONTENT:CONTENT:EDIT:BEGIN',
  ({componentId}) => ({componentId})
);


export const endEditingContent = createAction(
  'EDITABLE_CONTENT:CONTENT:EDIT:END',
  ({componentId}) => ({componentId})
);


export const updateInitialContent = createAction(
  'EDITABLE_CONTENT:CONTENT:INITIAL_CONTENT:UPDATE',
  ({contentId, initialContent}) => ({contentId, initialContent})
);


export const updateDraftContent = createAction(
  'EDITABLE_CONTENT:CONTENT:DRAFT:UPDATE',
  ({contentId, draftContent}) => ({contentId, draftContent})
);


export const clearDraftContent = createAction(
  'EDITABLE_CONTENT:CONTENT:DRAFT:CLEAR',
  ({contentId}) => ({contentId})
);


/**
 * @todo TESTS: Add all
 */
export const deregisterEditableContent = createAction(
  'EDITABLE_CONTENT:CURRENT_EDITABLE_CONTENT:DEREGISTER',
  ({componentId}) => {

    _invariant(componentId instanceof Identifier, 'Expected componentId to be instance of Identifier');

    return {componentId};

  }
);


// WEBPACK FOOTER //
// ./src/modules/editableContent/actions/index.js